export const ReportExportFileType = {
  Pdf: 'Pdf',
  Excel: 'Excel',
} as const;
export type ReportExportFileType = (typeof ReportExportFileType)[keyof typeof ReportExportFileType];
